module.exports = __webpack_public_path__ + "img/xiaohongbao.721150c3.gif";